import React from 'react'
import UserManagement from '../components/userManagement/UserManagement'

const UserManagementPage = () => {
    return (
        <div className='outletConainer'>
            <UserManagement />
        </div>
    )
}

export default UserManagementPage
